























































import { Component, Watch, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import MenuItem from '@/components/menu/menu-item.vue';
import { mixins } from 'vue-class-component';
import MainMenuGroupingMixin, { MainMenuLayoutTab } from '@/views/layout/navigation/mixins/main-menu-grouping-mixin';
import MenuDropdown from '@/components/menu-dropdown.vue';

@Component({
  components: {
    MenuItem,
    MenuDropdown
  }
})
export default class MainMenuGroupingMobileDropdown extends mixins(MainMenuGroupingMixin) {
  handleMainSelectClick() {
    this.close();
  }

  handleAction(tab: any, event: any) {
    if(tab.click) {
      tab.click(event);
    }

    if(!tab.subItems) {
      this.close();
    }
  }

  handleClickOutside() {
    if(this.$store.state.mobile.menuGroupingOpen) {
      this.close();
    }
  }

  close() {
    this.$store.commit('mobileMenuGroupingOpen', false);
  }
}
